import { render, staticRenderFns } from "./UserEditView.vue?vue&type=template&id=6451b0e4"
import script from "./UserEditView.vue?vue&type=script&lang=js"
export * from "./UserEditView.vue?vue&type=script&lang=js"
import style0 from "./UserEditView.vue?vue&type=style&index=0&id=6451b0e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports